import { ClockIcon } from "@heroicons/react/24/outline";
import CiroModal from "../../../../shared/CiroModal";
import classnames from "classnames";
import StartFromPriorSearchRow from "./StartFromPriorInternalSearchRow";
import { gql, useQuery } from "@apollo/client";
import { StartFromPriorInternalSearchRow_AutopilotSession } from "./StartFromPriorInternalSearchRow";
import Loading from "../../../../shared/Loading";
import {
  InternalCuratedSearchFilters,
  StartFromPriorInternalSearchModal_AutopilotSessionQuery,
  StartFromPriorInternalSearchModal_AutopilotSessionQueryVariables,
} from "../../../../../__generated__/graphql";
import CiroLink from "../../../../shared/CiroLink";

const StartFromPriorInternalSearchModal_AutopilotSession = gql`
  query StartFromPriorInternalSearchModal_AutopilotSession {
    autopilotSessions(input: { searchType: internal, uniqueOnName: true }) {
      id
      ...StartFromPriorInternalSearchRow_AutopilotSession
    }
  }
  ${StartFromPriorInternalSearchRow_AutopilotSession}
`;
const StartFromPriorInternalSearchModal = ({
  isOpen,
  onClose,
  setSavedFilters,
}: {
  isOpen: boolean;
  onClose: () => void;
  setSavedFilters: (filters: InternalCuratedSearchFilters) => void;
}) => {
  const { data, loading, error } = useQuery<
    StartFromPriorInternalSearchModal_AutopilotSessionQuery,
    StartFromPriorInternalSearchModal_AutopilotSessionQueryVariables
  >(StartFromPriorInternalSearchModal_AutopilotSession);

  return (
    <CiroModal isOpen={isOpen} onClose={onClose} size="LARGE">
      <div>
        <h1 className={classnames("flex", "items-center", "gap-2")}>
          <ClockIcon className="w-5 h-5" />
          Start from prior search
        </h1>
        {loading && <Loading size="SMALL" />}
        {!loading && (
          <div>
            <div className={classnames("text-sm", "neutral-900", "mb-4")}>
              Choose a search path to continue your prior search:
            </div>
            {!data?.autopilotSessions.length && (
              <div>No prior searches found.</div>
            )}
            {error && (
              <div className={classnames("text-sm", "text-red-500", "py-2")}>
                Error loading prior searches. Please contact support at{" "}
                <CiroLink href="mailto:support@ciro.io" unstyled={true}>
                  support@ciro.io
                </CiroLink>{" "}
                if the issue persists.
              </div>
            )}
            <div
              className={classnames(
                "flex",
                "flex-col",
                "gap-2",
                "max-h-[400px]",
                "overflow-y-auto",
              )}
            >
              {data?.autopilotSessions.map((session) => (
                <StartFromPriorSearchRow
                  key={session.id}
                  session={session}
                  onClose={onClose}
                  setSavedFilters={setSavedFilters}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </CiroModal>
  );
};

export default StartFromPriorInternalSearchModal;
